import { render, staticRenderFns } from "./relatedAll.vue?vue&type=template&id=0ef8eda6&scoped=true&"
import script from "./relatedAll.vue?vue&type=script&lang=js&"
export * from "./relatedAll.vue?vue&type=script&lang=js&"
import style0 from "./relatedAll.vue?vue&type=style&index=0&id=0ef8eda6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef8eda6",
  null
  
)

export default component.exports